module.exports = __webpack_public_path__ + "static/media/mladi-ambasadori_logo.1e3ca37d.png";